import React from 'react';
import UnitPricesTable from '../component/unitPricesTable'
import { downloadHandler } from '../common/helper'

class ANZUnitPricesOA extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ANZUnitPricesData: [],
            errorMessageShow: false,
        }
    }

    componentDidMount() {
        document.title = 'Unit Prices';
        fetch('/api/unit-prices?reportName=onepathunitprices',{
            method:'GET',
            headers:{
              'Content-Type':'application/json;charset=UTF-8',
            },
          mode:'same-origin',
            cache:'default'
          })
           .then(res =>res.json())
           .then((data) => {
                if(data.status === "FAILURE"){
                    this.setState({
                        errorMessageShow: true
                    })
                }
                if(data.status === 'SUCCESS'){
                    this.setState({
                        ANZUnitPricesData:data.data
                    })
                }
            })
    }

    shouldComponentUpdate(nextState){
        return nextState.errorMessageShow !== this.state.errorMessageShow
    }

    render() {
        const {ANZUnitPricesData} = this.state;
        const uniquetableHeader = [
            "OneAnswer Multi-Asset-Class Funds",
            "OneAnswer Single-Asset-Class Funds",
            "OneAnswer KiwiSaver Scheme - Multi-Asset Class",
            "OneAnswer KiwiSaver Scheme - Single-Asset Class",
            "SIL Mutual Fund",
            "MFL Mutual Fund",
            "SIL Employer Scheme",
        ];

        let tabledataMap =[];
        uniquetableHeader.map((header)=>{
            const tableData = ANZUnitPricesData.filter((item)=> item.columnHeading === header)
            tabledataMap.push({
                tableHeader: header,
                tableData: tableData,
            })
         })
          const now = new Date();
          const formatter = new Intl.DateTimeFormat('en-NZ', {
                    timeZone: 'Pacific/Auckland',
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                           });

          const formattedDateTime = formatter.format(now);

        return (
                <div class="container">
                    <h1 class="header1">Current Unit Prices – {formattedDateTime}</h1>
                    <div style={this.state.errorMessageShow?{display:"block", marginBottom: "30px"}:{display:"none"}}>
                        <div class="alert alert-danger" role="alert" style={{marginBottom: "0px"}}>
                            <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" style={{marginRight:"8px"}}></span>
                            <span class="sr-only">Error: </span>
                            Data is not temporary unavailable at the moment, please try again later. We apologies any inconvinence caused by this
                        </div>
                    </div>
                    <form class="form-inline">
                        {/* Download */}
                        <div class="dropdown downloadIcon">
                            <button className="download-button" type="button" id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Download
                                <svg className="download-icon"></svg>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                <li><a onKeyDown={e=> e.key === 'Enter' && downloadHandler('pdf', 'onepathunitprices')}
                                       onClick={() => downloadHandler('pdf', 'onepathunitprices')} className="dropdown-item" tabIndex='0'>Acrobat (PDF) file</a></li>
                                <li><a onKeyDown={e=> e.key === 'Enter' && downloadHandler('csv', 'onepathunitprices')}
                                       onClick={() => downloadHandler('csv', 'onepathunitprices')} className="dropdown-item" tabIndex='0'>CSV (comma delimited)</a></li>
                                <li><a onKeyDown={e=> e.key === 'Enter' && downloadHandler('excel', 'onepathunitprices')}
                                       onClick={() => downloadHandler('excel', 'onepathunitprices')} className="dropdown-item" tabIndex='0'>Excel</a></li>
                                <li><a onKeyDown={e=> e.key === 'Enter' && downloadHandler('xml', 'onepathunitprices')}
                                       onClick={() => downloadHandler('xml', 'onepathunitprices')} className="dropdown-item" tabIndex='0'> XML file with report
                                    data</a></li>
                            </ul>
                        </div>
                        {/* Table */}
                        {
                                tabledataMap.map((item) =>
                                <UnitPricesTable header={item.tableHeader} tableData={item.tableData}/> )
                        }
                    </form>
                </div>
        )
    }
}

export default ANZUnitPricesOA;
